const handleDeleteEquipmentModels = {
  text: 'Do you really want to delete the device',
  title: 'DELETE EQUIPMENT'
};

export default handleDeleteEquipmentModels;
